// src/i18n/en/lockerTypes.js
const lockerTypes = {
    name: 'Locker Type |||| Locker Types',
    title: 'Locker Types',
    titles: {
        list: 'Locker Types',
        create: 'Create Locker Type',
        edit: 'Edit Locker Type',
    },
    fields: {
        id: 'ID',
        name: 'Type Name',
        description: 'Description',
        hotel: 'Hotel',
        hotelId: 'Hotel',
        'hotel.name': 'Hotel',
        type_name: 'Type Name',
        search_placeholder: 'Search types...',
        hotel_selection: 'Hotel Selection',
        createdAt: 'Created Date',
        updatedAt: 'Updated Date'
    },
    actions: {
        create: 'Create Locker Type',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        save: 'Save Changes',
        create_submit: 'Create Type',
        more_actions: 'More actions'
    },
    messages: {
        no_types: 'No locker types',
        no_types_found: 'No types found for the selected hotel.',
        no_types_description: 'Locker types help you categorize your lockers. Create the first type to get started.',
        no_hotel_selected: 'No hotel selected',
        select_hotel_to_view: 'Select a hotel to view locker types',
        loading: 'Loading types...',
        create_success: 'Locker Type created successfully',
        update_success: 'Locker Type updated successfully',
        delete_success: 'Locker type deleted successfully',
        access_denied: 'Access Denied.',
        create_info: 'Locker types help categorize your lockers by size, purpose, or capacity. Each type is associated with a specific hotel.',
        edit_warning: 'Note: If this locker type is already assigned, changes may affect its display and categorization.',
        update_error: 'Error updating the locker type'
    },
    validation: {
        name_required: 'Name is required (min. 2 characters)',
        name_min_length: 'Name is required (min. 2 characters)',
        name_max_length: 'Name cannot exceed 100 characters',
        description_max_length: 'Description cannot exceed 500 characters.',
        hotel_required: 'You must select a hotel.'
    },
    dialogs: {
        delete_title: 'Delete Locker Type',
        delete_message: 'Are you sure you want to delete the locker type "%{name}"?',
        delete_warning: 'This action cannot be undone.'
    },
    sections: {
        details: 'Locker Type Details',
        hotel_assignment: 'Hotel Assignment',
        new_type_title: 'New Locker Type',
        new_type_subtitle: 'Complete the details to create a new locker type',
        edit_type_title: 'Edit Locker Type',
        edit_type_subtitle: 'Modify the locker type details'
    },
    help: {
        name: 'Descriptive name for the locker type',
        description: 'Optional description of the locker type',
        hotel: 'Hotel that this locker type belongs to'
    },
    filters: {
        search: 'Search types...',
        hotel: 'Hotel',
        all_hotels: 'All hotels'
    },
    labels: {
        type_management: 'Locker Type Management',
        type_details: 'Type Details',
        hotel_info: 'Hotel Information',
        general_info: 'General Information'
    },
    notifications: {
        created: 'Locker Type created successfully',
        updated: 'Locker Type updated successfully',
        deleted: 'Locker type deleted successfully'
    },
    errors: {
        create: 'Error creating the locker type',
        update: 'Error updating the locker type',
        delete: 'Error deleting the locker type',
        load: 'Error loading locker types'
    },
    ui: {
        type_list: 'Locker Type List',
        create_new_type: 'Create New Type',
        edit_type: 'Edit Type',
        type_information: 'Type Information',
        no_types_available: 'No types available',
        search_types: 'Search types...',
        filter_by_hotel: 'Filter by hotel'
    }
};

export default lockerTypes;
